import "../style/apply-page.css";
import StyledPage from "./StyledPage";
import ApplyForm from "../components/ApplyForm";
import Bg1 from "../assets/apply-bg1.svg";
import Down from "../assets/icon-chevron-down.svg";
import ClassType from "../assets/apply-type.svg";
import Bg2 from "../assets/apply-bg2.svg";
import Notice from "../assets/apply-notice.svg";
import Prep from "../assets/apply-prep.svg";

const ApplyPage = () => {

  return (
    <StyledPage>
      <div className={'apply-page'}>
        <div className={'apply-first-frame'}>
          <img className={'apply-first-frame-bg'} src={Bg1} alt={''}/>
          <ApplyForm/>
          <div className={'apply-scroll-down'}>
            <span>자세한 강습 정보</span>
            <img className={'apply-scroll-icon'} src={Down} alt={''}/>
          </div>
        </div>
        <div className={'apply-second-frame'}>
          <div className={'apply-title'}>
            <div className={'apply-title-num'}>01</div>
            <div className={'apply-title-text'}>강습 형태</div>
          </div>
          <img className={'apply-class-type'} src={ClassType} alt={''}/>
        </div>
        <div className={'apply-blank-bg'} style={{background: '#EBF5FE'}}>
          <div className={'apply-third-frame m-col reverse'}>
            <img className={'apply-third-bg'} src={Bg2} alt={''}/>
            <img className={'apply-notice'} src={Notice} alt={''}/>
            <div className={'apply-title right'}>
              <div className={'apply-title-num'} style={{color: '#BCD7EE'}}>02</div>
              <div className={'apply-title-text'}>강습 안내사항</div>
            </div>
          </div>
        </div>
        <div className={'apply-blank-bg'} style={{background: '#DAECFD'}}>
          <div className={'apply-fourth-frame m-col'}>
            <div className={'apply-title'}>
              <div className={'apply-title-num'} style={{color: '#AED0ED'}}>03</div>
              <div className={'apply-title-text'}>강습 준비물</div>
            </div>
            <img className={'apply-prep'} src={Prep} alt={''}/>
          </div>
        </div>
      </div>
    </StyledPage>
)
}

export default ApplyPage;